<template>
  <div class="pt-2">
    <v-card class="col-12 mb-4 pb-0" max-width="900">
      <v-data-table
        :headers="headers"
        :items="items"
        calculate-widths
        item-key="order_id"
        scrollable
        class="pl-1 pr-1"
        hide-default-footer
        :items-per-page="viewCount"
        mobile-breakpoint="0"
      >
        <template v-slot:[`item.paid_at`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.paid_at }}
          </p>
        </template>

        <template v-slot:[`item.order_id`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.order_id }}
          </p>
        </template>

        <template v-slot:[`item.order_name`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.order_name }}
          </p>
        </template>

        <template v-slot:[`item.payment_method`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.payment_method | paymentMethodConversion }}
          </p>
        </template>
        <template v-slot:[`item.paid_amount`]="{ item }">
          <p class="mt-3 text-center caption">
            {{ item.paid_amount | comma }}
          </p>
        </template>
        <template slot="no-data">
          <div>내역이 없습니다.</div>
        </template>
      </v-data-table>
    </v-card>
    <div v-if="items.length > 0" class="text-center">
      <v-container class="pa-0">
        <v-row justify="center">
          <v-col cols="12" class="pa-0">
            <v-container class="max-width">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/membership/filters.js";

export default {
  data() {
    return {
      headers: [
        {
          text: "결제일시",
          align: "center",
          sortable: false,
          value: "paid_at",
          width: 160,
          filterable: false,
        },
        {
          text: "주문번호",
          align: "center",
          value: "order_id",
          sortable: false,
          width: 200,
          filterable: false,
        },
        {
          text: "서비스명",
          align: "center",
          value: "order_name",
          sortable: false,
          filterable: false,
        },
        {
          text: "결제타입",
          align: "center",
          value: "payment_method",
          sortable: false,
          width: 100,
        },
        {
          text: "결제금액",
          align: "center",
          value: "paid_amount",
          sortable: false,
          width: 100,
          filterable: false,
        },
      ],
      items: [],
      page: 1,
      pageCount: 1,
      viewCount: 20,
      search_type: {
        offset: 0,
        limit: 20,
      },
    };
  },
  methods: {
    setParams: function(params) {
      this.items = params.list;
      this.pageCount = Math.ceil(
        Number(params.count) / Number(this.search_type.limit)
      );
    },
    searchTotalPayment: async function() {
      //결제 내역 조회
      try {
        let result = await M.api(
          M.entry("/get/membership/orders/payments"),
          this.search_type
        );
        await this.setParams(result);
      } catch (e) {
        //console.log(e);
      }
    },
  },
  watch: {
    page: function() {
      this.new_page = this.page;
    },
  },
  computed: {
    new_page: {
      get: function() {
        return this.page;
      },
      set: async function(newValue) {
        this.search_type.offset = (newValue - 1) * this.search_type.limit;
        await this.searchTotalPayment();
      },
    },
  },
  components: {},
  mixins: [CommonMixin],
  filters: Filters,
};
</script>
